import { Smartphone } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { track } from "@/lib/analytics-plausible";

interface Props {
  link: string;
  currency: string;
  productId?: string;
  productKind?: string;
  className?: string;
  variant?: "default" | "outline";
  size?: "default" | "sm" | "lg";
}

/**
 * Renders an external link to the provider-hosted mobile-money checkout
 * (Paystack / Flutterwave). Tracks `payment_started` on click.
 */
export function MobileMoneyButton({
  link,
  currency,
  productId,
  productKind,
  className,
  variant = "default",
  size = "lg",
}: Props) {
  const { t } = useTranslation();
  return (
    <Button asChild className={className} variant={variant} size={size}>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() =>
          track.paymentStarted({ product_id: productId, currency, ...(productKind ? { kind: productKind } : {}) })
        }
      >
        <Smartphone className="mr-2 h-4 w-4" />
        {t("commerce.payWithMobileMoney", "Pay with Mobile Money")} ({currency})
      </a>
    </Button>
  );
}
